import React, { useEffect, useState, useRef } from 'react';
import './DragPreview.css';

const DragPreview = ({ type, icon }) => {
  const [position, setPosition] = useState(null);
  const rafId = useRef(null);

  useEffect(() => {
    let currentPosition = null;
    
    const updatePosition = () => {
      if (currentPosition) {
        setPosition(currentPosition);
      }
      rafId.current = requestAnimationFrame(updatePosition);
    };

    const handleMouseMove = (e) => {
      if (e.buttons === 0) return;
      
      // Get the element under the cursor
      const elementsUnder = document.elementsFromPoint(e.clientX, e.clientY);
      // Update position regardless of what's under the cursor
      currentPosition = {
        x: e.clientX + 15,
        y: e.clientY + 15
      };
    };

    const handleDragOver = (e) => {
      e.preventDefault();
      e.stopPropagation();
      
      currentPosition = {
        x: e.clientX + 15,
        y: e.clientY + 15
      };
    };

    window.addEventListener('mousemove', handleMouseMove, true);
    window.addEventListener('dragover', handleDragOver, true);
    rafId.current = requestAnimationFrame(updatePosition);

    return () => {
      window.removeEventListener('mousemove', handleMouseMove, true);
      window.removeEventListener('dragover', handleDragOver, true);
      if (rafId.current) {
        cancelAnimationFrame(rafId.current);
      }
    };
  }, []);

  if (!position) return null;

  return (
    <div 
      className="drag-preview"
      style={{
        position: 'fixed',
        transform: `translate3d(${position.x}px, ${position.y}px, 0)`,
        zIndex: 999999,
        pointerEvents: 'none',
        left: 0,
        top: 0
      }}
    >
      <div className="drag-preview-content">
        <span className="preview-icon">{icon}</span>
        <span className="preview-type">{type}</span>
      </div>
    </div>
  );
};

export default DragPreview; 